export default {
  data() {
    return {
      keyword: null,
      displaySuggestion: false,
      keywordSuggestions: []
    }
  },
  watch: {
    keyword() {
      this.getKeywords(this.keyword)
    },
    'model.keyword'() {
      this.getKeywords(this.model.keyword)
    }
  },
  methods: {
    getKeywords(keyword) {
      if (!keyword) {
        this.keywordSuggestions = []
        return
      }
      if (window.keywordSuggestions) {
        const keywordSuggestion = window.keywordSuggestions.find(ks => ks.keyword === keyword)
        if (keywordSuggestion) {
          this.keywordSuggestions = keywordSuggestion.results
          return
        }
      }
      const apiUri = `keyword_suggestions?keyword=${encodeURIComponent(keyword)}`
      this.$store.dispatch('apiGet', apiUri).then(res => {
        this.keywordSuggestions = res.data.data
        window.keywordSuggestions = window.keywordSuggestions || []
        window.keywordSuggestions.push({ keyword: keyword, results: this.keywordSuggestions })
      })
    },
    showSuggestion() {
      this.displaySuggestion = true
    },
    hideSuggestion() {
      this.displaySuggestion = false
    },
    ageRanges(defaultText = '指定なし') {
      const ageRanges = [{ key: null, name: defaultText }]
      const MAX_AGE = 80
      const MIN_AGE = 18
      for (let i = MIN_AGE; i < MAX_AGE; i++) {
        ageRanges.push({
          key: i,
          name: `${i}歳`
        })
      }
      ageRanges.push({ key: MAX_AGE, name: '80歳以上' })
      return ageRanges
    }
  }
}
